// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.small-datepicker[data-v-3464d4f9] {\r\n  width: 150px;\r\n  /* Adjust width as desired */\n}\r\n", ""]);
// Exports
module.exports = exports;
